import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SubastasService = /** @class */ (function () {
    function SubastasService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.baseUrl;
        this.ultimoResultadoSubject = new BehaviorSubject({});
        this.ultimoResultado$ = this.ultimoResultadoSubject
            .asObservable()
            .pipe(distinctUntilChanged());
    }
    SubastasService.prototype.getSubasta = function (id) {
        return this.httpClient.get(this.baseUrl + '/subastas/' + id);
    };
    SubastasService.prototype.getSubastas = function () {
        return this.httpClient.get(this.baseUrl + '/subastas');
    };
    SubastasService.prototype.getLoteSeguido = function (id_lote) {
        return this.httpClient.get(this.baseUrl + '/lotes-seguidos/' + id_lote);
    };
    SubastasService.prototype.deleteLoteSeguido = function (id_lote) {
        return this.httpClient.delete(this.baseUrl + '/lotes-seguidos/' + id_lote);
    };
    SubastasService.prototype.postLoteSeguido = function (id, id_lote, notificar_sms, notificar_email, notificar_dispositivo) {
        return this.httpClient
            .post(this.baseUrl + '/lotes-seguidos/', {
            _id: id,
            _id_lote: id_lote,
            _notificar_sms: notificar_sms,
            _notificar_email: notificar_email,
            _notificar_dispositivo: notificar_dispositivo
        })
            .pipe(map(function (loteseguido) {
            return loteseguido;
        }));
    };
    SubastasService.prototype.getCantidadUsuariosLotes = function (id_lote) {
        return this.httpClient.get(this.baseUrl + '/cantidad-usuarios-lote/' + id_lote);
    };
    SubastasService.prototype.getDepartamentos = function () {
        return this.httpClient.get(this.baseUrl + '/departamentos');
    };
    SubastasService.prototype.getCategorias = function () {
        return this.httpClient.get(this.baseUrl + '/categorias');
    };
    SubastasService.prototype.getSubastasParametros = function (categoriaList, marcasList, departamentoList, periodo) {
        return this.httpClient.post(this.baseUrl + '/subastas-filtrado', {
            _categorias: categoriaList,
            _marcas: marcasList,
            _departamentos: departamentoList,
            _periodo: periodo
        });
    };
    SubastasService.prototype.getUltimoPeriodo = function () {
        return this.httpClient.get(this.baseUrl + '/periodo-actual');
    };
    SubastasService.prototype.getSubastasByPeriodo = function (idPeriodo) {
        return this.httpClient.get(this.baseUrl + '/subastas-periodo/' + idPeriodo);
    };
    SubastasService.prototype.getPeriodos = function () {
        return this.httpClient.get(this.baseUrl + '/periodos');
    };
    SubastasService.prototype.getSubastaGanador = function (idLote) {
        return this.httpClient.get(this.baseUrl + '/subasta-ganador/' + idLote);
    };
    SubastasService.prototype.getSeguidoresLote = function (idLote) {
        return this.httpClient.get(this.baseUrl + '/seguidores-lote/' + idLote);
    };
    SubastasService.prototype.setUltimoResultado = function (data) {
        this.ultimoResultadoSubject.next(data);
    };
    SubastasService.prototype.fechaMysqlAfechaJs = function (fecha) {
        if (typeof fecha !== 'undefined') {
            return fecha
                .replace(/-/g, '/')
                .replace('T', ' ')
                .replace(/\..*|\+.*/, '');
        }
    };
    SubastasService.ngInjectableDef = i0.defineInjectable({ factory: function SubastasService_Factory() { return new SubastasService(i0.inject(i1.HttpClient)); }, token: SubastasService, providedIn: "root" });
    return SubastasService;
}());
export { SubastasService };
